module.exports = __webpack_public_path__ + "static/img/ding4.546ab50.png";


//////////////////
// WEBPACK FOOTER
// ./src/imges/ding4.png
// module id = U19g
// module chunks = 0